import { render, staticRenderFns } from "./ServiceJoinStep2Contentsogcbd.vue?vue&type=template&id=30be85b0"
import script from "./ServiceJoinStep2Contentsogcbd.vue?vue&type=script&lang=js"
export * from "./ServiceJoinStep2Contentsogcbd.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/devopsfs01/workspace/dev-rca-mobile/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('30be85b0')) {
      api.createRecord('30be85b0', component.options)
    } else {
      api.reload('30be85b0', component.options)
    }
    module.hot.accept("./ServiceJoinStep2Contentsogcbd.vue?vue&type=template&id=30be85b0", function () {
      api.rerender('30be85b0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/page/common/ServiceJoinStep2Contentsogcbd.vue"
export default component.exports